module.exports = __webpack_public_path__ + "static/ruberto-map-blur-872de16aa41f2121dec2b79cf77950f7.jpg";